import type { TFunction } from 'react-i18next';
// Import Components
import { Tag } from '@geneui/components';
// Import Constants
import { l, AvailabilityColors } from 'constants/common';

export const dataTableColumnsConfigs = (t: TFunction) => {
    return {
        columns: [
            {
                text: l.Permission,
                dataKey: 'Permission',
                sortable: true,
            },
            {
                text: l.Availability,
                dataKey: 'Availability',
                sortable: true,
                colRenderer: (isAvailable) => {
                    return (
                        <Tag
                            name={isAvailable ? t(l.Yes) : t(l.No)}
                            appearance="minimal"
                            cornerRadius="smooth-radius"
                            color={isAvailable ? AvailabilityColors.Available : AvailabilityColors.Unavailable}
                        />
                    );
                },
            },
        ],
    };
};
